import { smsApi } from "api/instances";
import { FileDownloader } from "utils/fileDownloader";

export const getAndDownloadAudienceUsers = async (
    audienceIds: string[], 
    sendToAllUsers: boolean, 
    filterByOptedIn: boolean, 
    fileName: string,
    successCallback?: (message: string) => void,
    errorCallback?: (message: string) => void) => 
{
    const file =  {
        name: fileName
    };

    try {
        const csvReport = await smsApi.getAudienceTotalCSV(audienceIds, sendToAllUsers, filterByOptedIn)
        new FileDownloader(file).downloadProvided(csvReport.data);

        if(successCallback)
            successCallback("Recipient list downloaded. Check your Downloads folder.");
    }
    catch {
        if(errorCallback)
            errorCallback("Something went wrong. Please try again later.")
    }
}